import { render, staticRenderFns } from "./DialogConfirmRemove.vue?vue&type=template&id=49275780&scoped=true&"
import script from "./DialogConfirmRemove.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmRemove.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmRemove.vue?vue&type=style&index=0&id=49275780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49275780",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDialog,VRow})
